import React from 'react';

const PALETTES = {
  blue: ['#4184F4', '#194AAF', '#C6DCFF'],
  yellow: ['#F9CA2A', '#B88100', '#FFF1AD'],
  green: ['#22C55E', '#15803D', '#BBF7D0'],
  purple: ['#9360F1', '#5B29B8', '#DFC8FF'],
  orange: ['#FFAE2B', '#BD6800', '#FFE1A0'],
};

export function CargoPackageVisual({ color = 'blue', packageType = 'box', size = 160 }) {
  const [fill, stroke, light] = PALETTES[color] || PALETTES.blue;
  return (
    <svg
      viewBox="0 0 160 155"
      width={size}
      height={size}
      role="img"
      aria-label={`${color} ${packageType}`}
      style={{ display: 'block', overflow: 'visible', filter: 'drop-shadow(0 6px 3px rgba(64, 40, 96, .15))' }}
    >
      <ellipse cx="80" cy="139" rx="56" ry="8" fill="#33245E" opacity=".12" />
      {packageType === 'box' && (
        <>
          <rect x="21" y="31" width="118" height="84" rx="11" fill={fill} stroke={stroke} strokeWidth="6" />
          <path d="M23 51 L80 76 L137 51 M80 76 V115" stroke={light} strokeWidth="4" fill="none" />
          <path d="M68 31 V115 H91 V31" fill={light} opacity=".75" />
        </>
      )}
      {packageType === 'envelope' && (
        <>
          <rect x="11" y="40" width="138" height="71" rx="11" fill={fill} stroke={stroke} strokeWidth="6" />
          <path d="M15 45 L80 81 L145 45" fill="none" stroke={light} strokeWidth="5" />
          <path d="M16 105 L60 71 M144 105 L100 71" fill="none" stroke={light} strokeWidth="4" />
        </>
      )}
      {packageType === 'tube' && (
        <g transform="rotate(-23 80 77)">
          <rect x="48" y="19" width="64" height="112" rx="15" fill={fill} stroke={stroke} strokeWidth="6" />
          <rect x="46" y="16" width="68" height="21" rx="8" fill={light} stroke={stroke} strokeWidth="5" />
          <rect x="46" y="112" width="68" height="21" rx="8" fill={light} stroke={stroke} strokeWidth="5" />
          <path d="M73 43 V105" stroke={light} strokeWidth="8" opacity=".7" />
        </g>
      )}
      {packageType === 'bag' && (
        <>
          <path d="M38 38 Q80 27 122 38 L135 120 Q80 135 25 120Z" fill={fill} stroke={stroke} strokeWidth="6" />
          <path d="M42 41 Q80 57 118 41" fill="none" stroke={light} strokeWidth="7" />
          <path d="M47 67 L112 67" stroke={light} strokeWidth="5" strokeDasharray="7 6" />
          <rect x="52" y="84" width="57" height="27" rx="7" fill="#fff" opacity=".82" />
        </>
      )}
    </svg>
  );
}

export function CargoPanda({ size = 115 }) {
  return (
    <svg viewBox="0 0 120 120" width={size} height={size} aria-hidden="true" style={{ display: 'block', filter: 'drop-shadow(0 7px 2px rgba(62, 47, 109, .2))' }}>
      <ellipse cx="60" cy="103" rx="40" ry="14" fill="#BFB1E5" opacity=".55" />
      <ellipse cx="29" cy="33" rx="19" ry="23" fill="#20223F" transform="rotate(-22 29 33)" />
      <ellipse cx="93" cy="33" rx="19" ry="23" fill="#20223F" transform="rotate(22 93 33)" />
      <path d="M35 88 Q25 97 25 112 L95 112 Q96 92 86 87" fill="#7750E4" stroke="#4E2C9B" strokeWidth="4" />
      <ellipse cx="60" cy="55" rx="46" ry="44" fill="#fff" stroke="#25253D" strokeWidth="4" />
      <ellipse cx="40" cy="51" rx="13" ry="18" transform="rotate(-19 40 51)" fill="#25253D" />
      <ellipse cx="81" cy="51" rx="13" ry="18" transform="rotate(19 81 51)" fill="#25253D" />
      <circle cx="43" cy="49" r="4" fill="#fff" /><circle cx="78" cy="49" r="4" fill="#fff" />
      <ellipse cx="60" cy="69" rx="8" ry="6" fill="#25253D" />
      <path d="M49 77 Q60 89 71 77" fill="none" stroke="#25253D" strokeWidth="3.5" strokeLinecap="round" />
      <ellipse cx="28" cy="73" rx="8" ry="4" fill="#FFBEC5" opacity=".85" />
      <ellipse cx="92" cy="73" rx="8" ry="4" fill="#FFBEC5" opacity=".85" />
      <path d="M29 24 Q60 -1 91 24" fill="#FFC94A" stroke="#E3A52D" strokeWidth="3" />
      <rect x="49" y="4" width="25" height="13" rx="7" fill="#FFC94A" stroke="#E3A52D" strokeWidth="2" />
      <path d="M44 105 L76 105" stroke="#FFDB80" strokeWidth="6" strokeLinecap="round" />
    </svg>
  );
}
